import React from 'react';
import { Box, Container } from '@mui/material';
import { SchoolPaymentInitiation } from '../components/SchoolPaymentInitiation';
import PageHeader from '../components/PageHeader';

const SchoolPayments: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <PageHeader 
        title="School Payments"
        subtitle="Manage your school subscriptions and invoice payments"
      />
      <Box sx={{ mt: 3 }}>
        <SchoolPaymentInitiation />
      </Box>
    </Container>
  );
};

export default SchoolPayments; 